import { Fragment } from 'react';
import { Typography } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const PatientInfo = (props: Props) => {
  const { disabled, register } = props;

  return (
    <Fragment>
      <SectionTitle title="1. 使用身體約束的理由" />
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        <Typography
          sx={{ lineHeight: '20px', margin: '20px 0 0 15px', fontSize: '14px' }}
        >
          住院患者由於疾病性質，通常表現為認知功能和運動能力受損。因此，他們可能嘗試移除或損壞治療設備。儘管已採取各種措施解決這一問題，但在某些情況下，使用身體約束成為必要。
        </Typography>
      </RowContainer>
    </Fragment>
  );
};

export default PatientInfo;
